import { render, staticRenderFns } from "./OrderDigitalRewardModal.vue?vue&type=template&id=48afcf5c&scoped=true&"
import script from "./OrderDigitalRewardModal.vue?vue&type=script&lang=js&"
export * from "./OrderDigitalRewardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48afcf5c",
  null
  
)

export default component.exports